export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
              了解我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              关于我们
            </h2>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-background-100 rounded-2xl p-8 md:p-10">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                69视频诞生于影迷观众对优质视频内容的热爱。我们深知在海量信息中寻找靠谱播放源的困难——弹窗广告、失效链接、模糊画质，这些痛点曾让无数观众苦恼。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                因此，我们发起69视频这个平台导航项目，旨在为观众提供一份经过人工审核的在线视频平台推荐清单。从香蕉视频、红桃视频到91视频、蜜桃视频，每一家收录平台都经过了播放流畅度、内容覆盖面和安全性三个维度的实测评估。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                我们不是内容的创造者，而是优质入口的整理者。69视频持续跟踪行业动态，及时更新平台信息，确保每一次推荐都经得起观众的检验。感谢你的信任，愿好内容常伴左右。
              </p>

              <div className="mt-8 pt-6 border-t border-background-200 grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
                <div>
                  <span className="block text-xl font-heading font-bold text-primary-500">2024</span>
                  <span className="text-xs text-foreground-500">项目启动年份</span>
                </div>
                <div>
                  <span className="block text-xl font-heading font-bold text-primary-500">人工审核</span>
                  <span className="text-xs text-foreground-500">平台收录机制</span>
                </div>
                <div>
                  <span className="block text-xl font-heading font-bold text-primary-500">持续更新</span>
                  <span className="text-xs text-foreground-500">内容维护节奏</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}